import { useTranslation } from 'react-i18next';

import { TypeStringDto } from 'app/api/apiClient/generated/types';

export const useGetCanadianProvinceList = (): TypeStringDto[] => {
  const { t } = useTranslation('common');

  const canadaProvinceList: TypeStringDto[] = [
    { id: 'AB', name: t('states.canada.alberta', 'Alberta') },
    { id: 'BC', name: t('states.canada.britishColumbia', 'British Columbia') },
    { id: 'MB', name: t('states.canada.manitoba', 'Manitoba') },
    { id: 'NB', name: t('states.canada.newBrunswick', 'New Brunswick') },
    { id: 'NL', name: t('states.canada.newfoundland', 'Newfoundland and Labrador') },
    { id: 'NT', name: t('states.canada.northwestTerritories', 'Northwest Territories') },
    { id: 'NS', name: t('states.canada.novaScotia', 'Nova Scotia') },
    { id: 'NU', name: t('states.canada.nunavut', 'Nunavut') },
    { id: 'ON', name: t('states.canada.ontario', 'Ontario') },
    { id: 'PE', name: t('states.canada.princeEdwardIsland', 'Prince Edward Island') },
    { id: 'QC', name: t('states.canada.quebec', 'Quebec') },
    { id: 'SK', name: t('states.canada.saskatchewan', 'Saskatchewan') },
    { id: 'YT', name: t('states.canada.yukon', 'Yukon') },
  ];

  return canadaProvinceList;
};
